import React, { useMemo } from 'react';
import { Container } from './AgencyHomeBarChart.styles';
import { theme } from '../../styles/constants';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';

const AgencyHomeBarChart = ({ chartData }) => {
  const data = useMemo(() => {
    const influencers = Object.keys(chartData);

    const influencerNames = Object.values(chartData).map(v => v.name);

    return influencers.map(influencerId => {
      const photos = chartData[influencerId].photo.earnings;
      const videos = chartData[influencerId].video.earnings;
      const bundles = chartData[influencerId].bundle.earnings;
      const subscription = chartData[influencerId].subscription.earnings;
      const other = chartData[influencerId].other.earnings;
      return {
        name: influencerNames,
        data: [photos, videos, bundles, subscription, other],
      };
    });
  }, [chartData]);

  const colors = ['#BADAF7', '#97C9F1', '#3E9BE4', '#1672BA', '#092F4D'];

  const categories = useMemo(() => {
    const influencers = Object.values(chartData).map(v => v.name);

    if (influencers.length < 10) {
      return [...influencers, ...Array(10 - influencers.length).fill('')];
    }
    return influencers;
  }, [chartData]);

  const options = {
    chart: {
      type: 'bar',
      backgroundColor: 'transparent',
      style: {
        fontFamily: 'Lexend',
      },
    },
    title: {
      text: '',
    },
    accessibility: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    legend: {
      itemStyle: {
        color: theme.colors.textColor,
        fontSize: 12,
      },
    },
    xAxis: {
      max: 9,
      categories,
      labels: {
        style: {
          color: theme.colors.textColor,
          fontSize: 11,
        },
      },
      gridLineColor: '#F3F4F6',
      gridLineDashStyle: 'Dot',
      gridLineWidth: 1,
    },
    yAxis: {
      title: {
        text: '',
      },
      gridLineColor: '#F3F4F6',
      gridLineDashStyle: 'Dot',
      labels: {
        formatter: function ({ value }) {
          return `$${value}`;
        },
        style: {
          color: theme.colors.textColor,
          fontSize: 12,
        },
      },
    },
    plotOptions: {
      series: {
        stacking: 'normal',
        dataLabels: {
          enabled: false,
        },
        borderWidth: 0,
        borderRadius: 5,
        pointWidth: 22,
      },
    },
    colors: colors,
    tooltip: {
      valueDecimals: 2,
      shared: true,
      style: {
        fontSize: 12,
      },
    },
    series: [
      {
        name: 'Photos',
        data: data.map(item => item.data[0]),
      },
      {
        name: 'Videos',
        data: data.map(item => item.data[1]),
      },
      {
        name: 'Bundles',
        data: data.map(item => item.data[2]),
      },
      {
        name: 'Subscriptions',
        data: data.map(item => item.data[3]),
      },
      {
        name: 'Other',
        data: data.map(item => item.data[4]),
      },
    ],
  };

  return (
    <Container>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Container>
  );
};

export default AgencyHomeBarChart;
